<!--
 * @Descripttion: 第三方行业大类类目下拉框，支持抖音，快手及单多选
 * @Version: 1.0.0
 * @Author: Li Yong
 * @Date: 2022-03-23 10:42:25
 * @LastEditors: 吴作杰 15727841808@163.com
 * @LastEditTime: 2023-09-01 09:39:11
-->
<template>
	<el-select
		v-bind="$attrs"
		v-model="cate"
		@change="change"
		:disabled="disabled"
		:size="size"
		:placeholder="placeholder"
		:filterable="filterable"
		:clearable="clearable"
		:multiple="multiple"
		:multiple-limit="multipleLimit"
	>
		<el-option v-for="item in optionList" :key="item.value" :label="item.label" :value="item.value" :disabled="item.disabled"> </el-option>
	</el-select>
</template>
<script>
import { mapGetters } from 'vuex';
export default {
	name: 'CategorySelect',
	props: {
		value: [String, Number, Array],
		// 是否添加全部选项，全部选项的value为0，需与后端约定
		addAll: {
			type: Boolean,
			default: false,
		},
		// 选中全部项，返回给外部为全部的values，例如：[{label: '全部', value: 0},{label: '数码', value: 1},{label: '数码', value: 2}]，选中全部，返回[1,2]
		backAllValues: {
			type: Boolean,
			default: false,
		},
		filterList: {
			type: Array,
			default: () => [],
		},
		platformId: {
			type: [Number, String],
			default: 1,
		},
	},
	data() {
		return {
			cate: this.value,
			optionList: [],
			list: [],
		};
	},
	watch: {
		value(val) {
			this.cate = val;
		},
	},
	computed: {
		...mapGetters(['dyCategoryList', 'ksCategoryList', 'spCategoryList']),
		disabled() {
			return this.$attrs.disabled || false;
		},
		// 输入框尺寸
		size() {
			return this.$attrs.size;
		},
		// 提示信息
		placeholder() {
			return this.$attrs.placeholder || '请选择';
		},
		// 是否可搜索
		filterable() {
			return this.$attrs.filterable === false ? this.$attrs.filterable : true;
		},
		//是否可以清空选项
		clearable() {
			return this.$attrs.clearable || false;
		},
		multiple() {
			return this.$attrs.multiple || false;
		},
		multipleLimit() {
			return this.$attrs['multiple-limit'] || 0;
		},
		allValues() {
			return this.backAllValues ? this.list.map(({ value }) => value) : [0];
		},
	},
	methods: {
		change(val) {
			if (this.multiple && val.length > 1) {
				if (val[val.length - 1] === 0) {
					this.cate = [0];
					this.$emit('input', this.allValues);
					return;
				}
				if (val[0] === 0) {
					val.shift();
					this.cate = val;
				}
			}
			this.$emit('input', val);
			this.$emit('change', val);
		},
		createOptions() {
			// 原始平台数据转化
			const temPF = {
				[dataMap.PLATFORM_DY.value]: this.dyCategoryList,
				[dataMap.PLATFORM_KS.value]: this.ksCategoryList,
				[dataMap.PLATFORM_SP.value]: this.spCategoryList,
			};
			const _allList = temPF[+this.platformId];
			// 如果有筛选进行筛选
			this.list = this.filterList.length ? this.filterList.map(item => _allList.find(({ value }) => item === value)) : _allList;
			const _list = [...this.list];
			// 如果需要添加全部添加全部
			this.addAll && _list.unshift({ label: '全部', value: 0 });
			this.optionList = _list;
		},
	},
	mounted() {
		this.createOptions();
	},
};
</script>
